import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { brandData } from '../data/mock';

export const ContactSection = () => {
  return (
    <section id="contact" className="contact-section py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-sm tracking-[0.3em] uppercase text-[#c9a962] mb-4 block">
            Bize Ulaşın
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-6">
            İletişim
          </h2>
          <div className="w-20 h-px bg-[#c9a962] mx-auto"></div>
        </div>

        {/* Contact Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-20">
          {/* Phone */}
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-6 border border-[#c9a962]/30 rounded-full flex items-center justify-center">
              <Phone className="text-[#c9a962]" size={24} strokeWidth={1.5} />
            </div>
            <h3 className="text-lg font-light text-white mb-2 tracking-wide">Telefon</h3>
            <a 
              href={`tel:${brandData.contact.phone.replace(/\s/g, '')}`}
              className="text-[#c0c0c0] hover:text-[#c9a962] transition-colors"
            >
              {brandData.contact.phone}
            </a>
          </div>

          {/* Email */}
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-6 border border-[#c9a962]/30 rounded-full flex items-center justify-center">
              <Mail className="text-[#c9a962]" size={24} strokeWidth={1.5} />
            </div>
            <h3 className="text-lg font-light text-white mb-2 tracking-wide">E-posta</h3>
            <a 
              href={`mailto:${brandData.contact.email}`}
              className="text-[#c0c0c0] hover:text-[#c9a962] transition-colors break-all"
            >
              {brandData.contact.email}
            </a>
          </div>

          {/* Address */}
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-6 border border-[#c9a962]/30 rounded-full flex items-center justify-center">
              <MapPin className="text-[#c9a962]" size={24} strokeWidth={1.5} />
            </div>
            <h3 className="text-lg font-light text-white mb-2 tracking-wide">Adres</h3>
            <p className="text-[#c0c0c0] leading-relaxed">
              {brandData.contact.address}
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a962]/20 to-transparent mb-16"></div>

        {/* Social Links */}
        <div className="text-center">
          <h3 className="text-lg font-light text-white mb-8 tracking-wide">
            Sosyal Medyada Bizi Takip Edin
          </h3>
          <div className="flex flex-wrap justify-center gap-6">
            {/* Main Brand */}
            <a 
              href={brandData.mainBrand.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-5 py-2 border border-[#c9a962]/30 text-[#c9a962] hover:bg-[#c9a962] hover:text-[#1a1a1a] transition-all duration-300"
            >
              <Instagram size={16} strokeWidth={1.5} />
              <span className="text-sm tracking-wide">DRM Kitchen</span>
            </a>
            
            {/* Sub Brands */}
            {brandData.subBrands.map((brand) => (
              <a 
                key={brand.id}
                href={brand.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-5 py-2 border border-white/10 text-[#c0c0c0] hover:border-[#c9a962]/30 hover:text-white transition-all duration-300"
              >
                <Instagram size={14} strokeWidth={1.5} />
                <span className="text-sm tracking-wide">{brand.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
